module.exports = __webpack_public_path__ + "img/f-4-2.602d50ae.png";